const deviceStatuses = [
  'Requested', 'Sent', 'Delivered'
];

export default deviceStatuses